/* Dekogreen — comportamiento de los bloques de info de la PDP.
   Dos custom elements independientes: <dk-tabs> y <dk-reviews-carousel>.
   Sin dependencias. Si el JS no carga, las pestañas se ven todas abiertas
   (ver el <noscript> del snippet) y el carrusel sigue siendo scrollable. */
(function () {
  'use strict';

  if (!window.customElements) return;

  /* ---------------------------------------------------------------- Tabs */
  if (!customElements.get('dk-tabs')) {
    customElements.define(
      'dk-tabs',
      class DkTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
          if (!this.tabs.length) return;

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index));
            tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
          });

          const initial = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
          this.select(initial === -1 ? 0 : initial, false);
        }

        select(index, focus) {
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.setAttribute('tabindex', active ? '0' : '-1');
            if (this.panels[i]) this.panels[i].hidden = !active;
          });
          if (focus !== false && this.tabs[index]) this.tabs[index].focus();
        }

        onKeydown(event, index) {
          const last = this.tabs.length - 1;
          let next = null;

          switch (event.key) {
            case 'ArrowRight':
              next = index === last ? 0 : index + 1;
              break;
            case 'ArrowLeft':
              next = index === 0 ? last : index - 1;
              break;
            case 'Home':
              next = 0;
              break;
            case 'End':
              next = last;
              break;
            default:
              return;
          }

          event.preventDefault();
          this.select(next);
        }
      }
    );
  }

  /* ------------------------------------- Scroll al widget de reseñas */
  // El header es pegajoso, así que un salto de ancla nativo deja el título
  // del widget debajo de la barra. Compensamos con su altura real.
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-dk-scroll]');
    if (!trigger) return;

    const id = (trigger.getAttribute('href') || '').trim();
    if (id.charAt(0) !== '#' || id.length < 2) return;

    const target = document.querySelector(id);
    if (!target) return; // sin destino, que el navegador haga lo suyo

    event.preventDefault();
    const header = document.querySelector('.section-header, .header-wrapper, header');
    const offset = header ? header.getBoundingClientRect().height : 0;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset - 16;

    window.scrollTo({
      top: top,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  });

  /* ----------------------------------------------------- Carrusel reseñas */
  if (!customElements.get('dk-reviews-carousel')) {
    customElements.define(
      'dk-reviews-carousel',
      class DkReviewsCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-dk-track]');
          this.prev = this.querySelector('[data-dk-prev]');
          this.next = this.querySelector('[data-dk-next]');
          if (!this.track) return;

          if (this.prev) this.prev.addEventListener('click', () => this.scrollBy(-1));
          if (this.next) this.next.addEventListener('click', () => this.scrollBy(1));
          this.track.addEventListener('scroll', () => this.scheduleSync(), { passive: true });
          window.addEventListener('resize', () => this.scheduleSync(), { passive: true });

          this.syncNav();
        }

        get step() {
          const card = this.track.firstElementChild;
          if (!card) return this.track.clientWidth;
          const gap = parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;
          return card.getBoundingClientRect().width + gap;
        }

        scrollBy(direction) {
          this.track.scrollBy({ left: this.step * direction, behavior: 'smooth' });
        }

        scheduleSync() {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.syncNav());
        }

        syncNav() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const left = this.track.scrollLeft;
          // 1px de margen: los navegadores redondean scrollLeft y el botón
          // se quedaba activo al final del recorrido.
          if (this.prev) this.prev.disabled = left <= 1;
          if (this.next) this.next.disabled = left >= max - 1;
        }
      }
    );
  }
})();
